import { Logo } from "@/modules/shared/ui/components/custom/logo"
import { Mail, Phone, ArrowRight } from "lucide-react"
import { Link } from "react-router-dom"

export function Footer() {
  return (
    <footer className="bg-[#1b2578] text-white rounded-t-4xl">
      <div className="mx-auto max-w-7xl px-6 py-16">

        {/* Top Section */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4 items-start">

          {/* Brand */}
          <div>
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">TEMPERED TALENT</span>
              <Logo className="h-8 w-auto sm:h-10" style={{ filter: "brightness(0) invert(1)" }} />
            </Link>


            {/* Mail */}
            <div className="mt-6 flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/30">
                <Mail size={18} />
              </div>
              <div>
                <p className="text-sm font-medium">Mail us</p>
                <a href="mailto:info@temperedtalent.com" className="text-sm text-white/70 hover:text-white transition">info@temperedtalent.com</a>
              </div>
            </div>

            {/* Call */}
            <div className="mt-4 flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/30">
                <Phone size={18} />
              </div>
              <div>
                <p className="text-sm font-medium">Call us</p>
                <a href="tel:+27100054738" className="text-sm text-white/70 hover:text-white transition">010 005 4738</a>
              </div>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><a href="#" className="hover:text-white">Features</a></li>
              <li><a href="#" className="hover:text-white">Contact</a></li>
              <li><a href="#" className="hover:text-white">Pricing</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><a href="#" className="hover:text-white">Support</a></li>
              <li><Link target="_blank" to="/legal/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link target="_blank" to="/legal/terms" className="hover:text-white">Terms & Conditions</Link></li>
              <li><Link target="_blank" to="/legal/data-processing-security" className="hover:text-white">Data Processing & Security</Link></li>
              <li><Link target="_blank" to="/legal/ai-transparency" className="hover:text-white">Automated Processing & AI Transparency</Link></li>
              <li><a href="#" className="hover:text-white">Payment</a></li>
            </ul>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="font-semibold mb-4">Subscribe Now</h4>
            <p className="text-sm text-white/70 mb-4">
              Subscribe to our newsletter *
            </p>

            <div className="relative">
              <input
                type="email"
                placeholder="Enter your Email.."
                className="w-full rounded-full bg-transparent border border-white/30 px-12 py-3 text-sm placeholder-white/50 focus:outline-none focus:border-white"
              />
              <Mail
                size={16}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-white/70"
              />
              <button className="absolute right-1 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-cyan-400 text-[#1b2578] hover:bg-cyan-300 transition">
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 border-t border-white/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/70">
          <p>
            © 2026 <span className="text-cyan-400">TEMPERED TALENT</span>. All Rights
            Reserved Created by Tempered Talent
          </p>

          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy & Terms.</a>
            <a href="#" className="hover:text-white">Contact Us</a>
          </div>
        </div>

      </div>
    </footer>
  )
}
